import { format } from 'date-fns';
import type { Locale } from 'date-fns/locale';
import { nb, sv } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

export const getDateLocale = (locale: string) => {
  switch (locale) {
    case 'nb':
      return nb;
    case 'sv':
      return sv;
  }
};

export enum FormatDateOption {
  HourMinute = 'HH:mm',
  YearMonthDay = 'yyyy-MM-dd',
  YearMonthDayHourMinute = 'yyyy-MM-dd HH:mm',
  DayMonthYear = 'dd MMMM yyyy',
  DayMonthYearHourMinutes = 'dd MMMM yyyy HH:mm',
  MonthShortYear2Digit = 'MMM yy',
}

/**
 * Format a date with time zone support (client-side utility)
 */
export const formatDateWithTimeZone = (
  date: Date,
  formatOption: FormatDateOption,
  timeZone: string,
  locale?: Locale,
) => {
  return formatInTimeZone(date, timeZone, formatOption, { locale });
};

/**
 * Format a date without time zone (client-side utility)
 */
export const formatDateWithoutTimeZone = (
  date: Date,
  formatOption: FormatDateOption,
  locale?: Locale,
) => {
  return format(date, formatOption, { locale });
};
